/** @jsx jsx */
import React from "react"
import { jsx } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"
import Layout from "@components/Layouts"
import Section from "@components/Section"
import TwoColumnSection, {
    Block as ColumnBlock,
    ImageBlock as ColumnImageBlock,
} from "@components/TwoColumnSection"
import CTAHeadingBlock from "@components/CTAHeadingBlock"
import SEO from "@components/seo"
import bookNowHeader from "@static/images/book-now/bookNowHeader.jpg"
import BannerBlock from "@components/BannerBlock"
import { rem } from "@src/theme"
import ImpactFooter from "@components/ImpactFooter"
import BookWorkshop from "@modules/ContactForms/book-workshop"
import HubspotForm from "@components/HubspotForm"
import HubspotEmbed from "@components/HubspotEmbed"

const PagesEventsContact = props => {


    const hubspotEmbed = {
        region: "na1",
        portalId: "21250167",
        formId: "e1cea603-ad9b-413b-a3b1-0980678a309a"
    }

    return (
        <>
            <SEO
                title="Events | Get in touch"
                pathname={props.location.pathname}
                image={bookNowHeader}
            // description={data.og.frontmatter.ogdescription}
            />

            <TwoColumnSection
                col1={
                    <ColumnBlock
                        styles={{
                            bg: "darkPurple",
                            color: "white",
                        }}
                    >
                        <CTAHeadingBlock
                            heading="Get in touch about our events!"
                            body="Make an enquiry below and our Events Team will be in touch."
                        />
                    </ColumnBlock>
                }
                col2={<ColumnImageBlock image={bookNowHeader} />}
            />

            <div
                sx={{
                    bg: "pink",
                    variant: "padding.medium",
                }}
            >
                <Section>
                    <BannerBlock title="Get in touch" noMb />
                    <div
                        sx={{
                            bg: "white",
                            maxWidth: rem(842),
                            mx: "auto",
                            width: '95%'
                        }}
                    >
                        <div
                            sx={{
                                width: "85%",
                                mx: "auto",
                                py: rem(70)
                            }}
                        >

                            <HubspotEmbed
                                portalId={hubspotEmbed.portalId}
                                formId={hubspotEmbed.formId}
                                region={hubspotEmbed.region}
                            />

                        </div>
                    </div>
                </Section>
            </div>

            <ImpactFooter noPt />
        </>
    )
}

export default PagesEventsContact
